import React from "react";
import { OffcanvasTitle } from "react-bootstrap";
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";

/**
 * @typedef {'start'|'end'|'bottom'|'top'} directionTypes
 *
 * @param {Object} props
 * @param {String} props.title
 * @param {directionTypes} props.direction
 * @param {Boolean} props.isOpen
 * @param {Function} props.onToggle
 * @param {String} props.children
 * @param {HTMLElement} props.minWidth
 * @returns {HTMLElement}
 */

const Drawer = ({ isOpen = false, onToggle, title = "", direction = "end", children, minWidth = "fit-content" }) => {
  return (
    <Offcanvas isOpen={isOpen} toggle={onToggle} direction={direction} style={{ minWidth: minWidth }} className='border-0'>
      <OffcanvasHeader tag='h5' toggle={onToggle} className='bg-primary btn-white-close'>
        <OffcanvasTitle className='text-white'>{title}</OffcanvasTitle>
      </OffcanvasHeader>
      <OffcanvasBody>{children}</OffcanvasBody>
    </Offcanvas>
  );
};

export default Drawer;
